import { h } from 'preact';

var GeoSearchToggle = function GeoSearchToggle(param) {
    var classNameLabel = param.classNameLabel, classNameInput = param.classNameInput, checked = param.checked, onToggle = param.onToggle, children = param.children;
    return /*#__PURE__*/ h("label", {
        className: classNameLabel
    }, /*#__PURE__*/ h("input", {
        className: classNameInput,
        type: "checkbox",
        checked: checked,
        onChange: onToggle
    }), children);
};

export { GeoSearchToggle as default };
